import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getUserSelector } from 'src/store/modules/user/selectors'
import { removeDataFromLocalStorage } from 'src/utils/localStorage'

export default function useClearVerificationEmailLinkTimer() {
  const userInfo = useAppSelector(getUserSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (userInfo && userInfo?.emailVerified) {
      dispatch(removeDataFromLocalStorage('TIME_OF_LINK_EXPIRATION', false))
    }
  }, [userInfo])
}
